import { FC } from 'react'
import { useAppStore } from '@/stores'

/**
 * 控制导航权限
 * @param param0
 * @returns
 */
export const NavAuth: FC<{ navCode: string; children: React.ReactElement }> = ({ navCode, children }) => {
  // const { navs } = useAppStore()

  // if (!navCode) {
  //   return null
  // }

  // const nav = navs.find((n) => n.code === navCode)
  // if (nav) {
  //   return children
  // }

  return null
}
